import useSWR from 'swr';

export function useIsCompanyDisabled(companyId?: string) {
  const { data: isCompanyDisabled } = useSWR(
    companyId ? `/api/disabled-companies/${companyId}` : null,
    () =>
      fetch(
        `${process.env.NEXT_PUBLIC_DOMAIN}/api/info/estate-not-enable/${companyId}`
      )
        .then((r) => r.json())
        .then(({ status }) => status === 1)
        .catch(() => {
          // ローカルのみfetchできなくても、無効化しない（false）と返す
          if (process.env.NODE_ENV === 'development') {
            return false;
          }
        })
  );
  return isCompanyDisabled;
}
